import { Controller } from "@hotwired/stimulus";
import Tribute from "tributejs";
import Trix from "trix";

export default class extends Controller {
  static values = {
    url: String,
  };

  connect() {
    if (this.hasUrlValue) {
      this.editor = this.element.editor;
      this.controller = this;
      this.initializeTribute();
    }
  }

  disconnect() {
    this.tribute.detach(this.element);
  }

  initializeTribute() {
    this.tribute = new Tribute({
      allowSpaces: true,
      lookup: "name",
      menuItemLimit: 5,
      menuShowMinLength: 1,
      values: this.fetchUsers,
    });
    this.tribute.attach(this.element);
    this.tribute.range.pasteHtml = this._pasteHtml.bind(this);
    this.element.addEventListener("tribute-replaced", this.replaced);
  }

  fetchUsers = (text, callback) => {
    const url = new URL(this.urlValue, window.location.origin);
    if (text.length) {
      url.searchParams.append("query", text);
    }
    fetch(url, {
      headers: { Accept: "application/json" },
    })
      .then((response) => response.json())
      .then((users) => callback(users))
      .catch((error) => callback([]));
  };

  replaced(e) {
    let mention = e.detail.item.original;
    let attachment = new Trix.Attachment({
      sgid: mention.sgid,
      content: mention.content,
    });
    this.editor.insertAttachment(attachment);
  }

  _pasteHtml(html, startPos, endPos) {
    let range = this.editor.getSelectedRange();
    let position = range[0];
    let length = endPos - startPos;

    this.editor.setSelectedRange([position - length, position]);
    this.editor.deleteInDirection("backward");
  }
}
